<div id="customer-list-component" class="component-inner-wrapper device-configuration-list-component-class">
    <main class="main-content">
        <div class="container">
            <div class="breadcrumb">
                <span class="ele_link" [routerLink]="['/user-management/customers']">USER MANAGEMENT</span>
                <span>></span>
                <span>Customer Management</span>
            </div>

            <div class="aggrid-criteria">
                <div class="grid-filter-criteria">
                    <div>
                        <h1 class="page-title">Customer Management</h1>
                    </div>
                    <div class="customer-filter">
                        <label class="col-form-label me-2">Customer</label>
                        <select class="custom-dropdown" [title]="selectedCustomer"
                                   [(ngModel)]="selectedCustomer" (change)="onCustomerDropdownChange($event)">
                                <option selected value="All">All</option>
                                <option *ngFor="let customer of customerList" [value]="customer.customerName">{{customer.customerName}}</option>
                        </select>
                    </div>

                    <div>
                        <label class="col-form-label me-1">Account #</label>
                        <input type="text" class="form-control custom-input mb-2" [(ngModel)]="accountNumberFilter" (ngModelChange)="onAccountNumberChange($event)">
                    </div>
                </div>

                <div class="add-customer-btn-wrapper">
                    <button
                      type="button"
                      class="btn-confirm"
                      *appHasPermission="RbacPermissions.UserMgmt_Customer_Add"
                      (click)="onAddCustomer()"
                    >
                        + Add Customer
                    </button>
                </div>

                <div *ngIf="false" class="grid-download-csv">
                    <!-- Export Button -->
                    <button class="button-download" (click)="downloadCustomers()" [disabled]="isLoading">
                        <span class="button-icon" *ngIf="!isLoading"><mat-icon>cloud_download</mat-icon></span>
                        <span class="button-icon" *ngIf="isLoading">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        </span>
                        <span class="button-text">{{ isLoading ? 'Exporting...' : 'Export' }}</span>
                    </button>
                </div>
            </div>
            <div class="content-wrapper content-wrapper-aggrid">
                <div class="component-ag-grid-wrapper customer-list-grid-shell"
                [style.--mc-ag-page-size]="paginationPageSize"
                [style.--mc-ag-host-height.px]="gridHostHeightPx"
                (contextmenu)="preventDefaultContextMenu($event)"
                mcAgGridCopyCellTooltip style="position: relative;">
                    <ag-grid-angular
                        class="ag-theme-alpine"
                        [rowModelType]="'infinite'"
                        [columnDefs]="columnDefs"
                        [paginationPageSize]="paginationPageSize"
                        [paginationPageSizeSelector]="pageSizeOptions"
                        [cacheBlockSize]="paginationPageSize"
                        [pagination]="true"
                        [datasource]="dataSource"
                        [defaultColDef]="defaultColDef"
                        (gridReady)="onGridReady($event)"
                        (filterChanged)="onFilterChanged()"
                        (paginationChanged)="onPaginationChanged($event)"
                        (cellContextMenu)="onCellContextMenu($event)"
                    >
                    </ag-grid-angular>
                    <div class="custom-context-menu"
                        [ngStyle]="{'top.px': contextMenuPosition.y, 'left.px': contextMenuPosition.x}"
                        *ngIf="contextMenuVisible">
                        <ul>
                            <li (click)="handleCopy()">Copy Value</li>
                        </ul>
                    </div>
                </div>
            </div>

        </div>
    </main>
</div>



